/* eslint-disable eqeqeq */
/* eslint-disable no-undef */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { damage } from "../Redux/Features/damageSlice";
import { getDynamicToken } from '../utils/authUtils';
import {
  Alert,
  AlertTitle,
  Stack,
  Modal,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import {
  zb1022path,
  zb1030path,
  zb1032path,
  zb1031apath,
  zb1031bpath,
  zb1031cpath,
  zb1020path,
  zb1025apath,
  zb1025bpath,
  zb1027apath,
  zb1027bpath,
  zb1028path,
  zb1021path,
  zb1026path,
  zb1016path,
  zb1017path,
  zb1003path,
  zb1005path,
  zb1004path,
  zb1014path,
  zb1015path,
  zb1012path,
  zb1013path,
  zb1002apath,
  zb1002bpath,
  zb1002cpath,
  zb1019path,
  zb1018path,
  zb1011path,
  zb1006Aapath,
  zb1008Apath,
  zb1009Apath,
  zb1010path,
  zb1007Aapath,
  zb1007Abpath,
  zb1007Acpath,
  zb1001Aapath,
  zb1001Abpath,
  zb1001Acpath,
  zb1006Abpath,
} from "../pathData";
import "./DamageSelection.css";

const DamageSelection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [classMap, setClassMap] = useState({
    zb1022: 0,
    zb1030: 0,
    zb1032: 0,
    zb1031: 0,
    zb1020: 0,
    zb1025: 0,
    zb1027: 0,
    zb1028: 0,
    zb1021: 0,
    zb1026: 0,
    zb1023: 0,
    zb1029: 0,
    zb1024: 0,
    zb1016: 0,
    zb1017: 0,
    zb1003: 0,
    zb1005: 0,
    zb1004: 0,
    zb1014: 0,
    zb1015: 0,
    zb1012: 0,
    zb1013: 0,
    zb1002: 0,
    zb1019: 0,
    zb1018: 0,
    zb1011: 0,
    zb1008A: 0,
    zb1009A: 0,
    zb1010: 0,
    zb1007A: 0,
    zb1001A: 0,
    zb1006A: 0,
  });

  const [stateDamageData, setStateDamageData] = useState({});
  const isDamageRecorded = useSelector(
    (state) => state.damage.isDamageRecorded
  );
  const [storageValue, setStorageValue] = useState(
    localStorage.getItem("lc_damage")
  );
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [confirmationModal, setShowConfirmationModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [open, setOpen] = useState(false);

  const breakin = useSelector((state) => state.breakin);

  const classNames = [
    "intensity01",
    "intensity02",
    "intensity03",
    "intensity04",
    "intensity05",
  ];

  const handleColorChange = (id) => {
    if (!isDamageRecorded) {
      const currentClassIndex = classMap[id];
      const nextClassIndex = (currentClassIndex + 1) % classNames.length;
      setClassMap({ ...classMap, [id]: nextClassIndex });
    }
  };

  const encodeData = (data) => {
    return data;
  };

  function convertJSON(json) {
    const result = [];

    for (const key in json) {
      const partCode = key.replace("zb", "");
      const intensity = json[key];
      result.push({ PartCode: partCode, Intensity: intensity });
    }

    return result;
  }

  useEffect(() => {
    const checkLocalStorage = () => {
      const updatedValue = localStorage.getItem("lc_damage");
      if (updatedValue !== storageValue) {
        setStorageValue(updatedValue);
      }
    };
    const interval = setInterval(checkLocalStorage, 1000);
    return () => clearInterval(interval);
  }, [storageValue]);

  const saveStateAsJSON = () => {
    if (Object.keys(stateDamageData).length > 0) {
      const claimNo = breakin.claim_number;

      const encClaimNo = encodeData(claimNo);

      const damageDataString = JSON.stringify(convertJSON(stateDamageData));

      var localStorageKeyForDamageData = "lc_damage";

      if (damageDataString.length > 0) {
        var localStorageData = JSON.parse(damageDataString);
      } else {
        var localStorageData = "No Damage Selected";
      }

      window.localStorage.setItem(
        localStorageKeyForDamageData,
        localStorageData
      );

      dispatch(damage.setDamageData(stateDamageData));

      const encDamageData = encodeData(damageDataString);
      saveDamageToDB(encClaimNo, encDamageData);
    } else {
      // Open warning dialog if no damage data is selected
      setShowWarningModal(true);
    }
  };


  async function saveDamageToDB(encClaimNo, encDamageData) {
    try {
      const dynamicToken = await getDynamicToken();

      const data = JSON.stringify({
        ClaimNo: encClaimNo,
        carDamagedData: encDamageData,
      });

      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/savePOIDamage`,
        data,
        {
          headers: {
            Authorization: `Bearer ${dynamicToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      dispatch(damage.setDamageRecorded(true));
      setShowSuccessModal(true);
    } catch (error) {
      console.error(error);
    }
  }


  const handleCloseModal = () => {
    setShowSuccessModal(false);
    setShowWarningModal(false);
    setShowConfirmationModal(false);
  };

  // useEffect(() => {
  //     if (showSuccessModal || showWarningModal) {
  //         const timer = setTimeout(() => {
  //             handleCloseModal();
  //         }, 4000);
  //         return () => clearTimeout(timer);
  //     }
  // }, [showSuccessModal, showWarningModal]);

  async function fetchDamage() {
    try {
      const damageData = await fetchDamageFromDB();
      // setStateDamageData(damageData);
      if (Object.keys(damageData).length > 0) {
        dispatch(damage.setDamageRecorded(true));
      }

      // Allocate a value of 1 to the rest of the elements in classMap
      const updatedDamageData = { ...classMap }; // Start with a copy of classMap
      for (const key in classMap) {
        const intensity = parseInt(damageData[key]) - 1 || 0; // Subtract 1 and default to 1 if intensity is -1
        updatedDamageData[key] = intensity >= 0 ? intensity : 0; // Ensure intensity is at least 0
      }
      const updatedDamageDataWithoutZeros = Object.fromEntries(
        Object.entries(updatedDamageData).filter(([key, value]) => value !== 0)
      );

      setStateDamageData(updatedDamageDataWithoutZeros);

      // Update state based on the condition
      // setDamageRecorded(isDamageRecorded);
      // dispatch(damage.setDamageRecorded(isDamageRecorded));

      if (isDamageRecorded) {
        // Set the state with updatedDamageData
        setClassMap(updatedDamageData);

        var localStorageKeyForDamageData = "lc_damage";

        var localStorageData = JSON.stringify(updatedDamageDataWithoutZeros);

        window.localStorage.setItem(
          localStorageKeyForDamageData,
          localStorageData
        );

        dispatch(damage.setDamageData({ stateDamageData }));
        // window.alert("Damage already selected. Press return to Claim Form to close this window.")
      }
    } catch (error) {
      console.error(error);
    }
  }


  async function fetchDamageFromDB() {
    try {
      const dynamicToken = await getDynamicToken();

      const encClaimNo = encodeData(breakin.claim_number);
      let data = JSON.stringify({
        ClaimNo: encClaimNo,
      });

      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/fetchPOIDamage`,
        data,
        {
          headers: {
            Authorization: `Bearer ${dynamicToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (
        response.data?.GetDataForPOICustomerResult &&
        response.data.GetDataForPOICustomerResult.Message &&
        response.data.GetDataForPOICustomerResult.Message.Error
      ) {
        return null;
      }

      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleGoBack = () => {
    window.close();
  };

  useEffect(() => {
    document.title = "Damage Selection";
    fetchDamage();
  }, [isDamageRecorded]);

  useEffect(() => {
    // Convert classMap to JSON format with indices mapped
    const stateJSON = {};
    for (const key in classMap) {
      const className = classNames[classMap[key]];
      const index = classNames.indexOf(className); // Get index directly from classNames array
      // Increment the index by 1 if it's within the range of classNames array
      const incrementedIndex = index !== -1 ? index + 1 : index;
      // Map the index instead of class name, but exclude if index is 1
      if (incrementedIndex !== 1) {
        stateJSON[key] = incrementedIndex;
      }
    }
    setStateDamageData(stateJSON);
  }, [classMap]);

  //////////////////////////////////////////////////////////

  const btnBackClaimForm_Click = () => {
    if (!isDamageRecorded) {
      // setShowWarningModal(true);
      setOpen(true);
    } else {
      window.close();
    }
  };

  return (
    <div className="mainarea">
      <div className="mainarea-sub">
        <div className="sub text-center" id="container">
          <div>
            <span id="spnMessage" className="error-message"></span>
          </div>

          <svg
            version="1.1"
            width="100%"
            id="Svg1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 612 800"
            className="svg-background"
          >
            <meta
              name="csp-nonce"
              content="47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU="
            />

            <path
              className={classNames[classMap["zb1022"]]}
              id="zb1022"
              onClick={() => handleColorChange("zb1022")}
              d={zb1022path}
            />
            <path
              className={classNames[classMap["zb1030"]]}
              id="zb1030"
              onClick={() => handleColorChange("zb1030")}
              d={zb1030path}
            />
            <path
              className={classNames[classMap["zb1032"]]}
              id="zb1032"
              onClick={() => handleColorChange("zb1032")}
              d={zb1032path}
            />
            <path
              className={classNames[classMap["zb1031"]]}
              id="zb1031"
              onClick={() => handleColorChange("zb1031")}
              d={zb1031apath}
            />
            <g>
              <path d={zb1031bpath} />
            </g>
            <g>
              <path d={zb1031cpath} />
            </g>
            <g>
              <path
                className={classNames[classMap["zb1020"]]}
                id="zb1020"
                onClick={() => handleColorChange("zb1020")}
                d={zb1020path}
              />
            </g>
            <g>
              <path
                id="zb1025"
                className={classNames[classMap["zb1025"]]}
                onClick={() => handleColorChange("zb1025")}
                d={zb1025apath}
              />
            </g>
            <g>
              <path d={zb1025bpath} />
            </g>
            <g>
              <path
                id="zb1027"
                className={classNames[classMap["zb1027"]]}
                onClick={() => handleColorChange("zb1027")}
                d={zb1027apath}
              />
            </g>
            <g>
              <path d={zb1027bpath} />
            </g>
            <g>
              <path
                id="zb1028"
                className={classNames[classMap["zb1028"]]}
                onClick={() => handleColorChange("zb1028")}
                d={zb1028path}
              />
            </g>
            <g>
              <path
                className={classNames[classMap["zb1021"]]}
                id="zb1021"
                onClick={() => handleColorChange("zb1021")}
                d={zb1021path}
              />
            </g>
            <g>
              <path
                id="zb1026"
                className={classNames[classMap["zb1026"]]}
                onClick={() => handleColorChange("zb1026")}
                d={zb1026path}
              />
            </g>
            <g>
              <polygon
                className={`st13 ${classNames[classMap["zb1023"]]}`}
                id="zb1023"
                onClick={() => handleColorChange("zb1023")}
                points="337,121.7 359.2,144.2 359.2,121.7"
              />
              <polygon
                className={`st13 ${classNames[classMap["zb1029"]]}`}
                id="zb1029"
                onClick={() => handleColorChange("zb1029")}
                points="256.5,144.2 278.7,121.7 256.5,121.7"
              />
              <rect
                x="281"
                y="134.4"
                width="54.4"
                height="3.7"
                id="zb1024"
                className={`st13 ${classNames[classMap["zb1024"]]}`}
                onClick={() => handleColorChange("zb1024")}
              />
            </g>
            <g>
              <g>
                <path
                  className={classNames[classMap["zb1016"]]}
                  id="zb1016"
                  onClick={() => handleColorChange("zb1016")}
                  d={zb1016path}
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  className={classNames[classMap["zb1017"]]}
                  id="zb1017"
                  onClick={() => handleColorChange("zb1017")}
                  d={zb1017path}
                />
              </g>
            </g>
            <g>
              <path
                className={classNames[classMap["zb1003"]]}
                id="zb1003"
                onClick={() => handleColorChange("zb1003")}
                d={zb1003path}
              />
            </g>
            <g>
              <path
                className={`st14 ${classNames[classMap["zb1005"]]}`}
                id="zb1005"
                onClick={() => handleColorChange("zb1005")}
                d={zb1005path}
              />
            </g>
            <g>
              <path
                className={classNames[classMap["zb1004"]]}
                id="zb1004"
                onClick={() => handleColorChange("zb1004")}
                d={zb1004path}
              />
            </g>
            <g>
              <g>
                <path
                  className={classNames[classMap["zb1014"]]}
                  id="zb1014"
                  onClick={() => handleColorChange("zb1014")}
                  d={zb1014path}
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  className={classNames[classMap["zb1015"]]}
                  id="zb1015"
                  onClick={() => handleColorChange("zb1015")}
                  d={zb1015path}
                />
              </g>
            </g>
            <g>
              <path
                className={classNames[classMap["zb1012"]]}
                id="zb1012"
                onClick={() => handleColorChange("zb1012")}
                d={zb1012path}
              />
            </g>
            <g>
              <path
                className={classNames[classMap["zb1013"]]}
                id="zb1013"
                onClick={() => handleColorChange("zb1013")}
                d={zb1013path}
              />
            </g>
            <g>
              <path
                className={classNames[classMap["zb1002"]]}
                id="zb1002"
                onClick={() => handleColorChange("zb1002")}
                d={zb1002apath}
              />
            </g>
            <g>
              <path
                className={classNames[classMap["zb1002"]]}
                d={zb1002bpath}
              />
            </g>
            <g>
              <path
                className={classNames[classMap["zb1002"]]}
                d={zb1002cpath}
              />
            </g>
            <g>
              <path
                className={classNames[classMap["zb1019"]]}
                id="zb1019"
                onClick={() => handleColorChange("zb1019")}
                d={zb1019path}
              />
            </g>
            <g>
              <path
                className={classNames[classMap["zb1018"]]}
                id="zb1018"
                onClick={() => handleColorChange("zb1018")}
                d={zb1018path}
              />
            </g>
            <g>
              <path
                className={`st15 ${classNames[classMap["zb1011"]]}`}
                id="zb1011"
                onClick={() => handleColorChange("zb1011")}
                d={zb1011path}
              />
            </g>
            <g>
              <g>
                <path
                  className={classNames[classMap["zb1006A"]]}
                  id="zb1006B"
                  onClick={() => handleColorChange("zb1006A")}
                  d={zb1006Aapath}
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  className={classNames[classMap["zb1008A"]]}
                  id="zb1008A"
                  onClick={() => handleColorChange("zb1008A")}
                  d={zb1008Apath}
                />
              </g>
              <g>
                <circle
                  id="zb1008B"
                  fill="#ff8080"
                  cx="270"
                  cy="640.2"
                  r="8.8"
                />
              </g>
              <g>
                <circle
                  id="zb1008C"
                  fill="#ff8080"
                  cx="290.4"
                  cy="640.2"
                  r="8.8"
                />
              </g>
            </g>
            <g>
              <path
                className={classNames[classMap["zb1009A"]]}
                id="zb1009A"
                onClick={() => handleColorChange("zb1009A")}
                d={zb1009Apath}
              />
            </g>
            <g>
              <circle id="zb1009B" fill="#ff8080" cx="323" cy="640.2" r="8.8" />
            </g>
            <g>
              <circle
                id="zb1009C"
                fill="#ff8080"
                cx="343.4"
                cy="640.2"
                r="8.8"
              />
            </g>
            <g>
              <path
                className={classNames[classMap["zb1010"]]}
                id="zb1010"
                onClick={() => handleColorChange("zb1010")}
                d={zb1010path}
              />
            </g>
            <g>
              <g>
                <path
                  className={classNames[classMap["zb1007A"]]}
                  id="zb1007A"
                  onClick={() => handleColorChange("zb1007A")}
                  d={zb1007Aapath}
                />
              </g>
              <g>
                <g>
                  <path
                    className={classNames[classMap["zb1007A"]]}
                    id="zb1007B"
                    onClick={() => handleColorChange("zb1007A")}
                    d={zb1007Abpath}
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    className={classNames[classMap["zb1007A"]]}
                    id="zb1007C"
                    onClick={() => handleColorChange("zb1007A")}
                    d={zb1007Acpath}
                  />
                </g>
              </g>
            </g>
            <g>
              <g>
                <path
                  id="zb1001A"
                  className={`intensity0 ${classNames[classMap["zb1001A"]]}`}
                  onClick={() => handleColorChange("zb1001A")}
                  d={zb1001Aapath}
                />
              </g>
              <g>
                <g>
                  <path
                    id="zb1001B"
                    className={`intensity0 ${classNames[classMap["zb1001A"]]}`}
                    onClick={() => handleColorChange("zb1001A")}
                    d={zb1001Abpath}
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    id="zb1001C"
                    className={`intensity0 ${classNames[classMap["zb1001A"]]}`}
                    onClick={() => handleColorChange("zb1001A")}
                    d={zb1001Acpath}
                  />
                </g>
              </g>
            </g>
            <path
              className={classNames[classMap["zb1006A"]]}
              id="zb1006A"
              onClick={() => handleColorChange("zb1006A")}
              d={zb1006Abpath}
            />

            <text
              id="txtIntensity1"
              x={50}
              y={720}
              dy=".35em"
              className="intensity-label"
            >
              No Damage
            </text>
            <rect
              id="DenoteIntensity1"
              x={150}
              y={710}
              width={25}
              height={25}
              className="intensity-rect intensity1"
            />
            <text
              id="txtIntensity2"
              x={370}
              y={720}
              dy=".35em"
              className="intensity-label"
            >
              Scratch-No Dent
            </text>
            <rect
              id="DenoteIntensity2"
              x={500}
              y={710}
              width={25}
              height={25}
              className="intensity-rect intensity2"
            />
            <text
              id="txtIntensity3"
              x={50}
              y={750}
              dy=".35em"
              className="intensity-label"
            >
              Light Dent
            </text>
            <rect
              id="DenoteIntensity3"
              x={150}
              y={740}
              width={25}
              height={25}
              className="intensity-rect intensity3"
            />
            <text
              id="txtIntensity4"
              x={400}
              y={750}
              dy=".35em"
              className="intensity-label"
            >
              Torn | Crack
            </text>
            <rect
              id="DenoteIntensity4"
              x={500}
              y={740}
              width={25}
              height={25}
              className="intensity-rect intensity4"
            />
            <text
              id="txtIntensity5"
              x={50}
              y={780}
              dy=".35em"
              className="intensity-label"
            >
              Heavy Dent
            </text>
            <rect
              id="DenoteIntensity5"
              x={150}
              y={770}
              width={25}
              height={25}
              className="intensity-rect intensity5"
            />
          </svg>
        </div>

        <div className="form-container">
          <div className="button-container">
            {!isDamageRecorded && (
              <button
                id="btnSubmitPOI"
                type="button"
                className="submit-button"
                onClick={() => setShowConfirmationModal(true)}
              >
                Save Car Damaged Parts
              </button>
            )}

            {/* <Dialog
              open={showSuccessModal}
              onClose={handleCloseModal}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Damage Saved Successfully"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Please confirm whether you would like to go back?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleGoBack} color="primary">
                  Yes
                </Button>
                <Button onClick={handleCloseModal} color="primary" autoFocus>
                  No
                </Button>
              </DialogActions>
            </Dialog> */}

            <Dialog
              open={confirmationModal}
              onClose={handleCloseModal}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"This action is irreversible"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Please ensure you have selected all damage before proceeding.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={saveStateAsJSON} color="primary">
                  Save Selected Damaged Parts
                </Button>
                <Button onClick={handleCloseModal} color="primary" autoFocus>
                  Go Back
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={showSuccessModal}
              onClose={handleCloseModal}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Damage Saved Successfully"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  You can now submit the claim form after filling all the
                  required fields.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={handleGoBack} color="primary">
                  Yes
                </Button> */}
                <Button onClick={handleCloseModal} color="primary" autoFocus>
                  Okay
                </Button>
              </DialogActions>
            </Dialog>

            <Modal
              open={showWarningModal}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Stack className="warning-modal" spacing={2}>
                <Alert severity="warning" onClose={handleCloseModal}>
                  <AlertTitle>
                    Sorry, it seems like you have not selected any damage.
                  </AlertTitle>
                </Alert>
              </Stack>
            </Modal>
          </div>

          <div className="button-container">
            {/* <button
              id="btnClaimForm"
              type="button"
              className="back-button"
              onClick={btnBackClaimForm_Click}
            >
              Back to Claim Form
            </button> */}

            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Are you sure?"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  It seems you have not saved your damage. Do you still want to
                  go back?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleGoBack} color="primary">
                  Yes
                </Button>
                <Button onClick={handleClose} color="primary" autoFocus>
                  No
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DamageSelection;
